import React, { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import PageLoader from '../../@jumbo/components/PageComponents/PageLoader';
import AddIntegration from './AddIntegration';
import ListIntegration from './ListIntegration';

const IntegrationOutput = ({ match }) => {
  const requestedUrl = match.url.replace(/\/$/, '');
  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Redirect exact from={`${requestedUrl}/`} to={`${requestedUrl}/listIntegrations`} />
        <Route path={`${requestedUrl}/listIntegrations`} component={ListIntegration} />
        <Route path={`${requestedUrl}/addIntegration`} component={AddIntegration} />

        <Route component={lazy(() => import('../ExtraPages/404'))} />
      </Switch>
    </Suspense>
  );
};

export default IntegrationOutput;
